module.exports = __webpack_public_path__ + "static/media/slider-bali-wedding-1.b721ba82.jpg";